<template>
	<div id="app">
	
		<div id="cover" v-if="coverShow"></div>
		
		<div id="msgBox" v-bind:class="{ on : msgBoxStatus }" v-if="msgBoxShow">
			<div>
				<p v-html="msgBoxInfo"></p>
				<button type="button" v-on:click="msgBoxClose">확인</button>
			</div>
		</div>
	
		<header class="commonBox" id="header">
			<div>
				<div>
					
					<div class="left">
						<router-link to="/" class="logo">
							<img src="@/assets/img/top_logo.svg">
						</router-link>
					</div>
					
					<div class="right">
						<nav>
							<router-link to="/">홈</router-link>
							<router-link to="/about">회사소개</router-link>
							<router-link to="/portfolio">포트폴리오</router-link>
							<router-link to="/contact">개발문의</router-link>
							<router-link to="/review">개발평가</router-link>
						</nav>
						
						<div id="navBtn" v-on:click="navOpen">
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>
					
				</div>
			</div>
		</header>
		
		<div id="headerLine"></div>
		
		<div id="navList" v-if="topNavActive" v-bind:class="{ on : topNavListActive }">
			<div>
				<div class="closeBtn" v-on:click="navClose">
					<div></div>
					<div></div>
				</div>
						
				<ul>
					<li><router-link to="/">홈</router-link></li>
					<li><router-link to="/about">회사소개</router-link></li>
					<li><router-link to="/portfolio">포트폴리오</router-link></li>
					<li><router-link to="/contact">개발문의</router-link></li>
					<li><router-link to="/review">개발평가</router-link></li>
				</ul>
				
				<ul class="mini">
					<li><router-link to="/policy/service">이용약관</router-link></li>
					<li><router-link to="/policy/personal">개인정보처리방침</router-link></li>
					<li><a href="http://pf.kakao.com/_xjuJPs" target="_blank">카카오채널<img src="@/assets/img/icon_link.svg"></a></li>
					<li><a href="https://blog.naver.com/134340kr" target="_blank">네이버 블로그<img src="@/assets/img/icon_link.svg"></a></li>
					<li><a href="https://kmong.com/@일삼사삼사공" target="_blank">크몽문의<img src="@/assets/img/icon_link.svg"></a></li>
					<li><a href="https://instagram.com/134340kr" target="_blank">인스타그램<img src="@/assets/img/icon_link.svg"></a></li>
				</ul>
			</div>
		</div>
		
		<div id="contentsBox">
			<div class="commonBox" id="loadingBox" v-if="introShow == true">
				<div>
					<div>
						<img src="@/assets/img/loading.svg">
					</div>
				</div>
			</div>
			
			<div class="contents" v-bind:class="{ on : !introShow }">
				<div class="commonBox" id="topVisualBox" v-if="topVisualTitle">
					<div>
						<div>

							<p class="title">{{ topVisualTitle }}</p>
							<p class="info">{{ topVisualSub }}</p>

						</div>
					</div>
				</div>
			
				<router-view></router-view>
			</div>
		</div>
		
		<footer class="commonBox" id="footerTopBox">
			<div>
				<div>
				
					<div class="left top">
						<img src="@/assets/img/top_logo.svg">
						<p>powered by <b>안드로우</b></p>
					</div>
					
					<div class="left">
						<p class="big">일삼사삼사공</p>
						<p><b>사업자등록번호</b>748-10-01866<span></span><b>대표</b>주명왕성</p>
						<p><b>개인정보처리담당자</b>주명왕성(010-4946-7841)</p>
						<p><b>주소</b>대구 중구 경상감영길 56, 2층 2A-36호</p>
					</div>
					
					<div class="right">
						<p class="big"><img src="@/assets/img/icon_contact.svg"><a href="tel: 1800-7841">1800-7841</a></p>
						<p><b>이메일</b><a href="mailto: contact@134340.kr">contact@134340.kr</a></p>
						<p><b>영업시간</b>09:00 ~ 18:00</p>
						<p><b>휴게시간</b>12:00 ~ 13:00</p>
						<p class="small">주말 및 공휴일 제외</p>
						<a href="https://blog.naver.com/134340kr" target="_blank">네이버 블로그<img src="@/assets/img/icon_right.svg" class="default"><img src="@/assets/img/icon_right_hover.svg" class="hover"></a>
						<a href="https://instagram.com/134340kr" target="_blank">인스타그램<img src="@/assets/img/icon_right.svg" class="default"><img src="@/assets/img/icon_right_hover.svg" class="hover"></a>
						<a href="https://kmong.com/@일삼사삼사공" target="_blank">크몽으로 문의하기<img src="@/assets/img/icon_right.svg" class="default"><img src="@/assets/img/icon_right_hover.svg" class="hover"></a>
					</div>
					
				</div>
			</div>
		</footer>
		
		<footer class="commonBox" id="footerLinkBox">
			<div>
				<div>
					
					<div class="left">
						<p>
							<router-link to="/policy/service">이용약관</router-link>
							<router-link to="/policy/personal"><b>개인정보처리방침</b></router-link>
							<a href="http://pf.kakao.com/_xjuJPs" target="_blank">카카오채널<img src="@/assets/img/icon_link.svg"></a>
						</p>
						<p>COPYRIGHT Ⓒ 일삼사삼사공 ALL RIGHTS RESERVED.</p>
					</div>
					
				</div>
			</div>
		</footer>
		
	</div>
</template>

<style>
	@font-face {
	font-family: "NEXON Lv1 Gothic";
	font-weight: 300;
	src: url("./assets/fonts/NEXONLv1GothicOTFLight.woff2") format("woff2"),
		url("./assets/fonts/NEXONLv1GothicOTFLight.woff") format("woff")
	}

	@font-face {
	font-family: "NEXON Lv1 Gothic";
	font-weight: 400;
	src: url("./assets/fonts/NEXONLv1GothicOTF.woff2") format("woff2"),
		url("./assets/fonts/NEXONLv1GothicOTF.woff") format("woff")
	}

	@font-face {
	font-family: "NEXON Lv1 Gothic";
	font-weight: 500;
	src: url("./assets/fonts/NEXONLv1GothicOTFBold.woff2") format("woff2"),
		url("./assets/fonts/NEXONLv1GothicOTFBold.woff") format("woff")
	}
	
	* { margin: 0; padding: 0; box-sizing: border-box; position: relative; letter-spacing: -0.5px; outline: none !important; outline: none; -webkit-tap-highlight-color: transparent; -webkit-appearance: none; border-radius: 0; border: 0 ; color: inherit; word-break: keep-all; }
	*:focus { outline: none; }
	*::placeholder { color: #CCC; }
	*::selection { background-color: #000; color: #FFF; }
	html, body { width: 100%; float: left; font-family: "NEXON Lv1 Gothic", sans-serif; font-weight: 400; font-size: 13px; color: #000; background-color: #FFF; overflow-x: hidden; }
	
	img { vertical-align: middle; max-width: 100%; }
	ul, li { list-style: none; }
	a { text-decoration: none; }
	input, select, button, textarea { appearance: none; -webkit-appearance: none; -webkit-border-radius: 0; border: 0; font-family: "NEXON Lv1 Gothic", sans-serif; font-weight: 400; }
	label, button { cursor: pointer; }
	textarea { resize: none; }
	
	#app { width: 100%; float: left; left: 0; }
	
	.commonBox { width: 100%; float: left; }
	.commonBox > div { width: 1200px; margin: 0 auto; }
	.commonBox > div > div { width: 100%; float: left; padding: 20px; }
	
	.left { float: left; }
	.right { float: right; }
	
	#cover { position: fixed; width: 100%; height: 100%; left: 0; top: 0; z-index: 100; }
	
	#msgBox { position: fixed; width: 100%; height: 100%; left: 0; top: 0; z-index: 100; background-color: rgba(0, 0, 0, 0.4); }
	#msgBox > div { width: 320px; float: left; background-color: #FFF; top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%); padding: 30px 20px; text-align: center; margin-top: 20px; opacity: 0; transition: all 0.5s; }
	#msgBox.on > div { margin-top: 0; opacity: 1; }
	#msgBox > div > p { width: 100%; float: left; font-size: 16px; font-weight: 400; line-height: 21px; text-align: center; margin-bottom: 20px; }
	#msgBox > div > button { width: 80px; height: 40px; background-color: #0000C8; color: #FFF; font-size: 13px; font-weight: 500; }
	
	#loadingBox { height: calc(100vh - 100px); text-align: center; }
	#loadingBox > div { height: 100%; }
	#loadingBox > div > div { height: 100%; }
	#loadingBox img { width: 100px; top: 50%; transform: translateY(-50%); }
	
	#header { position: fixed; width: 100%; background-color: #FFF; border-bottom: 1px solid #DDD; z-index: 10; }
	#header > div > div { padding: 0 20px; }
	#header > div > div > div { height: 60px; line-height: 60px; }
	#header .logo { width: 130px; display: inline-block; vertical-align: middle; }
	#header nav { float: left; }
	#header nav > a { font-size: 14px; font-weight: 400; margin-right: 20px; vertical-align: middle; }
	
	#navBtn { width: 30px; height: 18px; display: inline-block; vertical-align: middle; cursor: pointer; }
	#navBtn > div { position: absolute; width: 100%; height: 2px; background-color: #000; right: 0; transition: all 0.5s; }
	#navBtn > div:nth-of-type(1) { top: 0; }
	#navBtn > div:nth-of-type(2) { width: 60%; top: 50%; margin-top: -1px; }
	#navBtn > div:nth-of-type(3) { bottom: 0; }
	#navBtn.open > div:nth-of-type(1) { top: 13px; transform: rotate(45deg); }
	#navBtn.open > div:nth-of-type(2) { width: 0; }
	#navBtn.open > div:nth-of-type(3) { bottom: 13px; transform: rotate(-45deg); }
	
	#navList { position: fixed; width: calc(100% + 300px); height: 100%; top: 0; right: -300px; z-index: 14; background-color: rgba(0, 0, 0, 0); transition: all 0.5s; }
	#navList.on { background-color: rgba(0, 0, 0, 0.4); right: 0; }
	#navList > div { position: absolute; width: 300px; height: 100%; background-color: #FFF; top: 0; right: 0; padding: 50px; transition: all 0.5s; }
	#navList > div > ul { width: 100%; float: left; margin-top: 50px; }
	#navList > div > ul > li { width: 100%; float: left; margin-bottom: 20px; }
	#navList > div > ul > li > a { float: left; font-size: 24px; color: #000; font-weight: 500; }
	#navList > div > ul.mini > li { width: 50%; }
	#navList > div > ul.mini > li > a { font-size: 13px; }
	#navList > div > ul.mini > li > a > img { height: 12px; margin-left: 5px; top: -2px; }
	#navList > div > .closeBtn { width: 30px; height: 24px; cursor: pointer; position: absolute; top: 20px; right: 20px; }
	#navList > div > .closeBtn > div { position: absolute; width: 100%; height: 2px; background-color: #000; right: 0; }
	#navList > div > .closeBtn > div:nth-of-type(1) { top: 12px; transform: rotate(45deg); }
	#navList > div > .closeBtn > div:nth-of-type(2) { bottom: 10px; transform: rotate(-45deg); }
	
	#contentsBox { padding-top: 60px; }
	#contentsBox > .contents { width: 100%; float: left; display: none; }
	#contentsBox > .contents.on { display: block; }
	
	#topVisualBox { background-color: #FBFBFB; border-bottom: 1px solid #E9E9E9; }
	#topVisualBox p { width: 100%; float: left; }
	#topVisualBox p.title { font-weight: 500; font-size: 32px; padding-top: 30px; }
	#topVisualBox p.info { font-weight: 400; font-size: 13px; margin-top: 5px; }
	
	#footerTopBox { border-top: 1px solid #DDD; background-color: #FFF; }
	#footerTopBox .left { width: 40%; position: absolute; left: 20px; bottom: 20px; }
	#footerTopBox .left.top { bottom: auto; top: 20px; }
	#footerTopBox .left.top > img { width: 110px; }
	#footerTopBox .left.top > p > b { font-weight: 500 !important; }
	#footerTopBox .left.top > p { color: #000; margin-top: 5px; font-size: 11px; }
	#footerTopBox .left > p { width: 100%; float: left; color: #666; font-size: 11px; margin-bottom: 3px; letter-spacing: -0.4px; }
	#footerTopBox .left > p:last-of-type { margin-bottom: 0; }
	#footerTopBox .left > p > span { display: inline-block; width: 1px; height: 10px; background-color: #CCC; margin: 0 10px; top: 50%; }
	#footerTopBox .left > p > b { margin-right: 5px; font-weight: 400; }
	#footerTopBox .left > p.big { color: #000; font-weight: 500; font-size: 14px; }

	#footerTopBox .right { width: 30%; }
	#footerTopBox .right > p { width: 100%; float: left; color: #777; font-size: 11px; margin-bottom: 3px; letter-spacing: -0.4px; }
	#footerTopBox .right > p > img { margin-right: 10px; height: 32px; margin-top: -6px; }
	#footerTopBox .right > p:last-of-type { margin-bottom: 0; }
	#footerTopBox .right > p > b { display: inline-block; width: 50px; font-weight: 400; color: #333; }
	#footerTopBox .right > p.big { color: #000; font-weight: 500; font-size: 32px; }
	#footerTopBox .right > p.small { font-size: 11px; color: #AAA; margin-bottom: 10px; }
	#footerTopBox .right > a { width: calc(calc(100% - 10px) / 2); margin-right: 10px; height: 45px; float: left; line-height: 43px; text-align: left; border: 1px solid #000; font-weight: 500; font-size: 13px; opacity: 1 !important; padding: 0 15px; margin-top: 10px; background-color: #FFF; transition: color 0.5s, background-color 0.5s; }
	#footerTopBox .right > a:nth-of-type(2n) { margin-right: 0; }
	#footerTopBox .right > a:last-of-type { width: 100%; margin-right: 0; }
	#footerTopBox .right > a > img { position: absolute; width: 20px; max-width: 20px; right: 15px; top: 50%; transform: translateY(-50%); transition: opacity 0.5s; }
	#footerTopBox .right > a > .default { opacity: 1; }
	#footerTopBox .right > a > .hover { opacity: 0; }

	#footerLinkBox { border-top: 1px solid #E1E1E1; background-color: #FFF; padding-bottom: 100px; }

	#footerLinkBox .left > p { width: 100%; float: left; color: #AAA; font-size: 9px; letter-spacing: -0.6px; }
	#footerLinkBox .left > p > a { float: left; font-size: 11px; opacity: 1 !important; color: #000; margin-right: 15px; margin-bottom: 5px; }
	#footerLinkBox .left > p > a > img { height: 10px; margin-left: 5px; top: -2px; }
	
	@media (hover: hover){
		#navBtn:hover > div:nth-of-type(2) { width: 100%; }
		#footerTopBox .right > a:hover { color: #FFF; background-color: #000; }
		#footerTopBox .right > a:hover > .default { opacity: 0; }
		#footerTopBox .right > a:hover > .hover { opacity: 1; }		
	}
	
	@media (max-width: 1240px){
		.commonBox > div { width: 100%; float: left; }
	}
	
	@media (max-width: 700px){
		nav { display: none; }
		
		#topVisualBox p.title { font-size: 24px; padding-top: 20px; }
		#topVisualBox p.info { font-size: 11px; }
		
		#footerTopBox .left { width: 100%; position: relative; left: 0; bottom: 0 !important; top: 0 !important; margin-bottom: 30px; }
		#footerTopBox .left > p { font-size: 12px; }
		#footerTopBox .right { width: 100%; }
	}
</style>

<script>
	var $;
	
	import favicon_mini from "@/assets/img/favicon_mini.png";
	import favicon_big from "@/assets/img/favicon_big.png";
	
	export default {
		head : {
			link : [
				{ rel : "icon", href : favicon_mini },
				{ rel : "shortcut icon", href : favicon_mini },
				{ rel : "apple-touch-icon-precomposed", href : favicon_big }
			]
		},
		data : function(){
			return {
				coverShow : false,
				msgBoxShow : false,
				msgBoxStatus : false,
				msgBoxInfo : "",
				introShow : true,
				topNavActive : false,
				topNavListActive : false,
				topVisualTitle : "",
				topVisualSub : ""
			}
		},
		methods : {
			msgBoxOpen : function(msg){
				$.msgBoxInfo = msg;
				$.msgBoxShow = true;
				setTimeout(function(){
					$.msgBoxStatus = true;
				}, 50);
			},
			msgBoxClose : function(){
				$.msgBoxShow = false;
				$.msgBoxStatus = false;
			},
			navOpen : function(){
				$.topNavActive = true;
				setTimeout(function(){
					$.topNavListActive = true;
				}, 50);
			},
			navClose : function(){
				$.topNavListActive = false;
				setTimeout(function(){
					$.topNavActive = false;
				}, 500);
			},
			navHide : function(){
				$.topNavActive = false;
				$.topNavListActive = false;
				window.scrollTo(0, 0);
			},
			pageOpen : function(){
				$.topNavActive = false;
				$.topNavListActive = false;
				
				setTimeout(function(){
					$.introShow = false;
				}, 1000);
				
			},
			pageLoad : function(){
				$ = this;
				
				var frmData = new FormData();
				frmData.append("prev", document.referrer);
				frmData.append("enter", $.$route.fullPath);
				
				$.$axios.post("//api.134340.kr/chart/visit", frmData, { headers: $.$axiosHeader }).then(function(res){
				});
			}
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/App.vue